/**
 * The three Wardogs factions a match side can play.
 *
 * Faction names are proper nouns from the game: they stay English in both
 * languages. Only the *label* of the field around them is translated.
 *
 * `icon` points at `frontend/public/factions/<slug>.webp`. The icons are
 * optional — FactionIcon falls back to the colour when a file is missing, so a
 * faction can be picked before its artwork lands.
 */
export interface Faction {
  slug: string
  label: string
  /** Fallback mark — taken from the artwork below, not sampled from it. */
  color: string
  icon: string
}

export const FACTIONS: Faction[] = [
  { slug: 'lonestar',  label: 'Lonestar',  color: '#3344dd', icon: '/factions/lonestar.webp' },
  { slug: 'valkyra',   label: 'Valkyra',   color: '#d62e28', icon: '/factions/valkyra.webp' },
  { slug: 'manticore', label: 'Manticore', color: '#3ba238', icon: '/factions/manticore.webp' },
]

export function factionOf(slug?: string | null): Faction | undefined {
  return slug ? FACTIONS.find(f => f.slug === slug) : undefined
}

export interface MatchTeam {
  name: string
  /** '' when the side is known but the faction it plays is not. */
  faction?: string
}

/** "TLL vs WDUK vs 331" — the title a match gets when none is typed. */
export function teamsTitle(teams: MatchTeam[]): string {
  return teams.map(t => t.name.trim()).filter(Boolean).join(' vs ')
}
